import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import classnames from "classnames";
import Grid from "@material-ui/core/Grid";
import Container from "../../common/Container";
import Banner from "../components/Banner";
import Menu from "../components/Menu";
import Sidebar from "../components/CategorySidebar";
import Products from "../components/CategoryProducts";
import Clients from "../components/Clients";
import PopularProducts from "../components/PopularProducts";
import OtherProducts from "../components/OtherProducts";
import SeoTexts from "../components/SeoTexts";
import BreadcrumbsContainer from "../components/BreadcrumbsContainer";
import {onPlatformSelector} from "../ducks/onPlatform";
import VTBBanner from "../components/VTBBanner";

import styles from "./products.module.scss";

function Category({onPlatform}) {
  return (
    <Grid
      container
      className={classnames(styles.root, {
        [styles.rootVTB]: onPlatform
      })}
    >
      {onPlatform !== `vtb` && (
        <Grid item xs={12} className={styles.breadcrumbs}>
          <Container>
            <BreadcrumbsContainer />
          </Container>
        </Grid>
      )}
      <Grid item xs={12} className={styles.banner}>
        {onPlatform !== `vtb` ? <Banner /> : <VTBBanner />}
      </Grid>
      <Grid item xs={12} className={styles.navigation}>
        <Menu />
      </Grid>
      <Grid item xs={12} className={styles.content}>
        <Container>
          <Grid container>
            <Grid item xs={12} lg={3}>
              <Sidebar />
            </Grid>
            <Grid item xs={12} lg={9}>
              <Products />
            </Grid>
          </Grid>
        </Container>
      </Grid>
      {onPlatform !== `vtb` && (
        <Grid item xs={12} className={styles.b2b}>
          <Clients />
        </Grid>
      )}
      <Grid item xs={12} className={styles.beforeFooterText}>
        <Container>
          <SeoTexts />
        </Container>
      </Grid>
      <Grid item xs={12} className={styles.popularProducts}>
        <PopularProducts />
      </Grid>
      <Grid item xs={12} className={styles.othersProducts}>
        <OtherProducts />
      </Grid>
    </Grid>
  );
}

Category.propTypes = {
  onPlatform: PropTypes.string
};

const mapStateToProps = (state) => ({
  onPlatform: onPlatformSelector(state)
});

export default connect(mapStateToProps)(Category);
